import * as React from 'react';

import { SimilarOffersContainer } from './container';
import { ISimilarOffersGroupsProps } from './groups_container';

export enum EModelTypes {
  UserBased = 'userBased',
  ItemBased = 'itemBased',
}

export function SimilarOffersGroupsComponent(props: ISimilarOffersGroupsProps) {
  return (
    <div>
        {!props.withoutCompetitors
          && <SimilarOffersContainer key={EModelTypes.ItemBased} modelType={EModelTypes.ItemBased}/>}
        <SimilarOffersContainer key={EModelTypes.UserBased} modelType={EModelTypes.UserBased}/>
    </div>
  );
}
